import RatingLevelsTitle from './rating-levels-title';

export default RatingLevelsTitle;
